module.exports = __webpack_public_path__ + "img/bell.25879142.svg";